// modules/CheckboxField.jsx
import React from "react";
import { Box, Typography, Checkbox } from "@mui/material";

const CheckboxField = ({ module, value, isEditable, onChange, fieldKey }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      marginBottom={2}
    >
      <Typography variant="body1">{module.label}</Typography>
      <Checkbox
        checked={!!value}
        onChange={(e) => onChange(fieldKey, e.target.checked)}
        disabled={!isEditable}
        color="primary"
      />
    </Box>
  );
};

export default CheckboxField;
